var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Inject, Watch } from 'vue-property-decorator';
import { BBadge, BButton } from 'bootstrap-vue';
import SideBar from '@/modules/main/components/SideBar.vue';
import UserAvatar from '@/modules/main/components/UserAvatar.vue';
import Avatar from '@/components/Avatar.vue';
import { dateToUiString, stringToDate } from '@/utils/dates';
import { lazyInject, Services, NotificationsService } from '@/services';
import { GetNotifications } from '@/graphql/queries/users';
import { NotificationType } from '@/dto/post';
import { PostToRoute } from '@/utils/posts';
var NotificationsBar = /** @class */ (function (_super) {
    __extends(NotificationsBar, _super);
    function NotificationsBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifications = [];
        _this.notificationsPage = 1;
        _this.hasMoreNotifications = true;
        _this.loading = false;
        _this.isVisible = false;
        return _this;
    }
    NotificationsBar.prototype.onNotificationsUpdate = function () {
        var _a, _b;
        this.notifications = ((_a = this.session) === null || _a === void 0 ? void 0 : _a.notifications.data) ? this.mapNotifications(this.session.notifications.data) : [];
        this.hasMoreNotifications = (_b = this.session) === null || _b === void 0 ? void 0 : _b.notifications.paginatorInfo.hasMorePages;
    };
    NotificationsBar.prototype.loadMore = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.notificationsPage += 1;
                        this.loading = true;
                        return [4 /*yield*/, this.$apollo.query({
                                query: GetNotifications,
                                variables: {
                                    page: this.notificationsPage,
                                },
                            })];
                    case 1:
                        data = (_b.sent()).data;
                        (_a = this.notifications).push.apply(_a, this.mapNotifications(data.notifications.data));
                        this.hasMoreNotifications = data.notifications.paginatorInfo.hasMorePages;
                        this.loading = false;
                        return [4 /*yield*/, this.onVisibilityChange()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsBar.prototype.onVisibilityChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isVisible) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service.markNotificationsRead([])];
                    case 1:
                        _a.sent();
                        this.$root.$emit('updateNotificationCounts');
                        return [3 /*break*/, 3];
                    case 2:
                        this.notifications.forEach(function (notification) {
                            notification.isNew = false;
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NotificationsBar.prototype.onClose = function () {
        this.isVisible = !this.isVisible;
        this.$root.$emit('updateSessionCounts');
        // this.$root.$emit('clearNotifications');
    };
    NotificationsBar.prototype.mapNotifications = function (notifications) {
        return notifications.map(this.mapNotification).filter(function (notification) { return notification; });
    };
    NotificationsBar.prototype.mapNotification = function (notification) {
        var id = notification.id, type = notification.type, created_at = notification.created_at, read_at = notification.read_at, notificationData = notification.data;
        var createdAt = stringToDate(created_at);
        switch (type) {
            case NotificationType.RECEIVE_EVENT_INVITATION_NOTIFICATION:
            case NotificationType.EVENT_INVITATION_CANCEL_NOTIFICATION:
            case NotificationType.NEW_EVENT_PARTICIPANT_NOTIFICATION:
            case NotificationType.NEW_SURVEY_PARTICIPANT_NOTIFICATION:
            case NotificationType.NEW_INTEREST_ON_NEIGHBOUR_HOOD_AID_NOTIFICATION:
            case NotificationType.EVENT_RESPONSE_NOTIFICATION:
            case NotificationType.NEW_LIKE_NOTIFICATION:
            case NotificationType.NEW_COMMENT_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    user: data.author,
                    linkToTitle: data.post_title,
                    linkTo: {
                        name: "activities." + PostToRoute[data.postable_type] + ".single",
                        params: { uuid: data.post_uuid },
                    },
                    isNew: !read_at,
                };
            }
            case NotificationType.NEW_SURROUNDING_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    linkToTitle: data.surrounding_platform_name,
                    linkTo: {
                        name: 'neighbourhood.information',
                        params: { id: data.surrounding_id },
                    },
                    isNew: !read_at,
                    logo: data.surrounding_platform_logo_path,
                };
            }
            case NotificationType.GROUP_SUBSCRIPTION_ADMIN_NOTIFICATION:
            case NotificationType.USER_JOINED_GROUP_BY_EMAIL_TO_ADMIN_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    user: data.author,
                    linkToTitle: data.group_title,
                    linkTo: {
                        name: "membership.admin",
                        params: { groupId: data.group_id },
                    },
                    isNew: !read_at,
                };
            }
            case NotificationType.CLOSED_GROUP_JOIN_REQUEST_TO_ADMIN_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    user: data.author,
                    linkToTitle: data.group_title,
                    linkTo: {
                        name: "membership.admin",
                        params: { groupId: data.group_id },
                    },
                    isNew: !read_at,
                };
            }
            case NotificationType.PUBLIC_GROUP_JOIN_TO_ADMIN_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    user: data.author,
                    linkToTitle: data.group_title,
                    linkTo: {
                        name: "membership.admin",
                        params: { groupId: data.request_uuid },
                    },
                    isNew: !read_at,
                };
            }
            case NotificationType.ATTACH_GROUPS_TO_COMMUNITY_NOTIFICATION:
            case NotificationType.ATTACH_GROUPS_TO_NEIGHBOURHOODS_NOTIFICATION:
            case NotificationType.JOIN_GROUP_REQUEST_APPROVED_TO_USER_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    linkToTitle: data.group_title,
                    groupName: data.group_title,
                    linkTo: {
                        name: "membership.information",
                        params: { groupId: data.group_id },
                    },
                    isNew: !read_at,
                };
            }
            case NotificationType.GROUP_INVITATION_NOTIFICATION: {
                var data = JSON.parse(notificationData);
                return {
                    id: id,
                    type: type,
                    readAt: read_at,
                    createdAt: dateToUiString(createdAt, { format: 'dd.MM.yyyy - HH:mm' }),
                    user: data.author,
                    linkToTitle: data.group_title,
                    linkTo: {
                        name: "gruppe.information",
                        params: { group: data.group_uuid },
                    },
                    invitationLinkTitle: String(this.$t('notifications.here')),
                    invitationLink: data.invitation_link,
                    isNew: !read_at,
                };
            }
        }
        return null;
    };
    NotificationsBar.prototype.isSurroundingType = function (type) {
        return type === NotificationType.NEW_SURROUNDING_NOTIFICATION;
    };
    NotificationsBar.prototype.onMenuItemClick = function () {
        this.$root.$emit('hideShowMenuClass');
    };
    NotificationsBar.prototype.closeNotificationBar = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isVisible = false;
                this.$root.$emit('updateSessionCounts');
                return [2 /*return*/];
            });
        });
    };
    NotificationsBar.prototype.mounted = function () {
        var _this = this;
        this.$root.$on('toggleNotifications', function () {
            _this.isVisible = !_this.isVisible;
        });
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], NotificationsBar.prototype, "session", void 0);
    __decorate([
        lazyInject(Services.NotificationsService),
        __metadata("design:type", NotificationsService)
    ], NotificationsBar.prototype, "service", void 0);
    __decorate([
        Watch('session.notifications', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NotificationsBar.prototype, "onNotificationsUpdate", null);
    __decorate([
        Watch('isVisible'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotificationsBar.prototype, "onVisibilityChange", null);
    __decorate([
        Watch('$route'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], NotificationsBar.prototype, "closeNotificationBar", null);
    NotificationsBar = __decorate([
        Component({
            components: {
                BBadge: BBadge,
                BButton: BButton,
                Avatar: Avatar,
                UserAvatar: UserAvatar,
                SideBar: SideBar,
            },
        })
    ], NotificationsBar);
    return NotificationsBar;
}(Vue));
export default NotificationsBar;
